import { OverlayRef } from '@angular/cdk/overlay';

export class McOverlayRef {

  constructor(private overlayRef: OverlayRef) { }

  close(): void {
    this.overlayRef.dispose();
  }
}
